import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { trackLinkClick } from '../utils/tracking/trackLinkClick';
import styles from './index.module.scss';
interface Props {
  userId: string;
  name: string;
  url?: string;
  pulseEventName: string;
}
const getProfileUrl = (userId: string): string => `/utente/${userId}`;
export const PrivateUserName = t0 => {
  const $ = _c(11);
  const {
    userId,
    name,
    url,
    pulseEventName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("headline-6", styles.name);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== url || $[2] !== userId) {
    t2 = url ?? getProfileUrl(userId);
    $[1] = url;
    $[2] = userId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== pulseEventName || $[5] !== userId) {
    t3 = () => trackLinkClick(userId, pulseEventName);
    $[4] = pulseEventName;
    $[5] = userId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== name || $[8] !== t2 || $[9] !== t3) {
    t4 = <h6 className={t1}><a href={t2} onClick={t3}>{name}</a></h6>;
    $[7] = name;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};